import { cn } from '@quadralize/utils'
import * as SwitchPrimitive from '@radix-ui/react-switch'
import * as React from 'react'
import { LabelWrapper } from '../label/label'

const Switch = React.forwardRef<
  React.ComponentRef<typeof SwitchPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root> & {
    label?: string
    required?: boolean
    error?: boolean
    helperText?: React.ReactNode
  }
>(({ className, label, id, required, error, helperText, ...props }, ref) => {
  const generatedId = React.useId()
  const switchId = id || generatedId

  return (
    <LabelWrapper
      label={label}
      id={switchId}
      required={required}
      error={error}
      helperText={helperText}
      labelPosition="right"
      className="cursor-pointer"
    >
      <SwitchPrimitive.Root
        id={switchId}
        className={cn(
          'peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus-ring focus-visible:ring-offset-2 focus-visible:ring-offset-bg-base disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-bg-muted',
          className,
        )}
        {...props}
        ref={ref}
        required={required}
      >
        <SwitchPrimitive.Thumb
          className={cn(
            'pointer-events-none block h-4 w-4 rounded-full bg-white shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0',
          )}
        />
      </SwitchPrimitive.Root>
    </LabelWrapper>
  )
})
Switch.displayName = SwitchPrimitive.Root.displayName

export { Switch }
